import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { RecordField } from '@app/models/record.model';
import { ApiService } from '@app/services/api.service';
import { DialogService } from '@app/services/dialog.service';
import { RecordService } from '@app/services/record.service';
import { AuthSelectors } from '@app/store/auth/auth.selectors';
import { SettingSelectors } from '@app/store/setting/setting.selectors';
import { NoteTitleInputParams } from '@care-connect-japan/ckweblib/lib/data/schema/params/library-params';
import { Store } from '@ngxs/store';
import * as lodash from 'lodash';

@Component({
  selector: 'app-student-record-item',
  templateUrl: './student-record-item.component.html',
})
export class StudentRecordItemComponent implements OnInit {
  @Input() studentForm!: FormGroup;
  @Input() expanded: boolean = false;
  originalFormValue: any;
  backgroundColor: string = '';
  records!: RecordField[];
  noteTitleParams!: NoteTitleInputParams;

  get name() {
    return this.studentForm?.get('name')?.value || '';
  }
  get firstLetter() {
    return this.name.charAt(0);
  }
  get record() {
    return this.studentForm?.get('record') as FormGroup;
  }
  get isSubmitted() {
    return this.record?.get('isSubmitted') as FormControl;
  }

  get isTouched() {
    return this.record.dirty;
  }

  get isSameAsOriginal(): boolean {
    return lodash.isEqual(this.originalFormValue, this.record?.value.items);
  }

  get isInitialized() {
    return this.record?.get('isInitialized') as FormControl;
  }

  get recordItems() {
    return this.record?.get('items') as FormArray;
  }

  constructor(
    protected dialogModalService: DialogService,
    protected store: Store,
    protected recordService: RecordService,
    protected apiService: ApiService,
    protected fb: FormBuilder
  ) { }

  ngOnInit(): void {
    if (this.record) {
      this.originalFormValue = lodash.cloneDeep(this.record.value);
    }
    this.backgroundColor = this.randomAvatarColor();
  }

  resetForm() {
    this.record.reset(this.originalFormValue);
  }

  clickExpand() {
    this.expanded = !this.expanded;
    if (this.expanded && !this.isInitialized.value) {
      this.loadTitleData();
    }
  }

  private customValidation() {
    const { activity, detail, date, images } = this.record.value;
    if (activity || detail || date || images.length > 0) {
      return true;
    }
    alert('記録を入力してください。');
    return false;
  }

  onSubmit() {
    if (this.isSubmitted.value) return;
    if (!this.customValidation()) return;
    this.isSubmitted.setValue(true);
    const payload = this.studentForm.value;
    console.log('Submitting form with payload:', payload);
    // call api to submit form data
    // call pop up if success
    // const msg = `${this.name}の記録を保存しました`;
    // const successDialog = this.dialogModalService.recordSubmitPopup(msg);
    // setTimeout(() => {
    //   successDialog.close();
    //   this.expanded = false;
    // }, 1500);

  }

  private randomAvatarColor() {
    const hue = Math.floor(Math.random() * 360); // any color
    const saturation = 60 + Math.random() * 20; // 60–80%
    const lightness = 25 + Math.random() * 15;  // 25–40% (dark!)
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  }

  editForm() {
    if (!this.isSubmitted.value) return;
    this.isSubmitted.setValue(false);
  }

  loadTitleData() {
    const profile = this.store.selectSnapshot(AuthSelectors.profile);
    const selecteTitles = this.store.selectSnapshot(SettingSelectors.selectedTitles);

    const { items } = selecteTitles!;
    const { id } = this.studentForm.value;
    const payload = {
      sdate: new Date(),
      objcd: id, //daicd
      titleSetKeys: this.recordService.getTitleSetKeys(items),
    };

    this.apiService.getNoteListDefault(payload).subscribe({
      next: (res) => {
        this.records = res ?? [];
        res.forEach((data) => {
          const dataForm = this.recordService.setRecordForm(profile, data);
          this.recordItems.push(dataForm);
        });
        this.originalFormValue = lodash.cloneDeep(this.record?.value);
        this.isInitialized.setValue(true);
      },
      error: () => {
        this.isInitialized.setValue(false);
      }
    });
  }

  getRecordForm(index: number) {
    return this.recordItems.at(index) as FormGroup;
  }
}
